import UploadDocumentFormComponent from "../../components/espace-document/UploadDocumentFormComponent";


export default function UploadDocumentBloc() {

      return (
        <div className="">
          <div className="">
            <UploadDocumentFormComponent />
          </div>
        </div>
      )
}